import { render, staticRenderFns } from "./shiftList.vue?vue&type=template&id=a6ffcac4&scoped=true&"
import script from "./shiftList.vue?vue&type=script&lang=js&"
export * from "./shiftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ffcac4",
  null
  
)

export default component.exports